import { render, staticRenderFns } from "./CalculationList.vue?vue&type=template&id=0ba09ae1&scoped=true"
import script from "./CalculationList.vue?vue&type=script&lang=js"
export * from "./CalculationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba09ae1",
  null
  
)

export default component.exports